export default __webpack_public_path__ + "static/media/Ravi-Chamria.638ec2d8.png";